module.exports = {
	"purchase_type": {
		"choose": "Vælg",
		"digital_document_basis": "Selvbetjening",
		"digital_document_review": "Juridisk tjek",
		"digital_document_advice": "Udvidet rådgivning",
		"registration": "Tinglysning",
		"upgrade_to_review": "Opgradering til Juridisk tjek",
		"upgrade_to_advice": "Opgradering til Udvidet rådgivning"
	}
};